import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";

import Isvg from "react-inlinesvg";
import { Calendar } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import * as locales from "react-date-range/dist/locale";
import { DOMAINS } from "../../../constants";
import moment from "moment";
import { format } from "date-fns";
import { Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import holidayIcon from '../../../assets/svg/holiday.svg'

function getMaxDaysInCurrentMonth(value) {
  const currentDate = new Date(value);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth(); // trenutni mesec

  // Postavlja datum na poslednji dan trenutnog meseca
  const date = new Date(year, month + 1, 0);
  return date.getDate(); // Vraća broj dana u tom mesecu
}

const LightTooltipHoliday = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#e61f00",
    color: "#fff",
    boxShadow: theme.shadows[1],
    fontSize: 14
  }
}))(Tooltip);

function iosDevice() {
  //return true;
  var userAgent = window.navigator.userAgent;
  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
    return true;
  } else {
    return false;
  }
}
/**
 * Custom datepicker
 * @author   Stefan Pantic
 */
class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();

    this.state = {};
  }

  componentDidMount() {
    let date = new Date();
    this.setState({
      date: new Date(),
    });

    this.setState({
      year: date.getFullYear(),
    });

    if (this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }

    document.addEventListener("mousedown", this.handleClickOutside);

    // if (typeof window != 'undefined') {
    //     window.stopVerifyFun = true
    // }
    if (this.props.openCalendar) {
      this.calculateWeekNumbersCalendar();
    }
  }
  componentDidUpdate(prevProps, prevState) {

    if (this.state.showCalendar && prevState.showCalendar != this.state.showCalendar) {
      this.calculateWeekNumbersCalendar();
    }
    if (this.props.openCalendar && prevProps.openCalendar != this.props.openCalendar) {
      this.calculateWeekNumbersCalendar();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    if (typeof window != "undefined") {
      window.stopVerifyFun = false;
    }
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState(
        {
          showCalendar: null,
        },
        () => {
          // if(typeof window != 'undefined'){
          //     window.stopVerifyFun = false
          // }
        }
      );
    }
  };
  clearCustomElements = () => {
    if (typeof window === 'undefined') return;
    let keyValue = this.props.keyValue;
    if (keyValue && parseInt(keyValue) > 0) {
      keyValue = parseInt(keyValue);
    }
    let daysIndex = 0;
    const days = document.getElementsByClassName("rdrDays");
    if (days?.length > 1 && keyValue > 1) {
      if (days[keyValue - 1]?.children?.length > 0) {
        daysIndex = keyValue - 1;
      } else if (days[days.length - 1]?.children?.length > 0) {
        daysIndex = days.length - 1;
      }
    }

    const weekDays = document.getElementsByClassName("rdrWeekDays");
    let weekDaysIndex = 0;
    if (weekDays?.length > 1 && keyValue > 1) {
      if (weekDays[keyValue - 1]?.children?.length > 0) {
        weekDaysIndex = keyValue - 1;
      } else if (weekDays[weekDays.length - 1]?.children?.length > 0) {
        weekDaysIndex = weekDays.length - 1;
      }
    }


    let rdrWeekDayWeekNumberLabelClassName = 'rdrWeekDayWeekNumberLabel';
    if (weekDays?.length > 1) {
      rdrWeekDayWeekNumberLabelClassName = `rdrWeekDayWeekNumberLabel rdrWeekDayWeekNumberLabel_${weekDaysIndex}`;
    }
    let elementsForRemove = document.getElementsByClassName(rdrWeekDayWeekNumberLabelClassName);
    while (elementsForRemove.length > 0) {
      elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
    }
    let rdrWeekNumberClassName = 'rdrWeekNumber';
    if (days?.length > 1) {
      rdrWeekNumberClassName = `rdrWeekNumber_${daysIndex}`;
    }
    elementsForRemove = document.getElementsByClassName(rdrWeekNumberClassName);
    while (elementsForRemove.length > 0) {
      elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
    }
  }
  calculateWeekNumberByDate = (dateStr) => {
    if (dateStr && dateStr !== NaN) {
      let date = new Date(dateStr);
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() - 1);
      const m = moment(date);
      const week = m.week();
      return week && week !== NaN ? week : null;
    } else {
      return null;
    }
  }

  calculateWeekNumbersCalendar = (number = 0) => {
    if (this.state.showCalendar || this.props.openCalendar) {
      if (typeof window === 'undefined') return;

      this.clearCustomElements();

      const weekDays = document.getElementsByClassName("rdrWeekDays");
      const days = document.getElementsByClassName("rdrDays");
      let newArray = days?.[0]?.children ?? [];


      let keyValue = this.props.keyValue;
      if (keyValue && parseInt(keyValue) > 0) {
        keyValue = parseInt(keyValue);
      }
      let daysIndex = 0;
      if (days?.length > 1 && keyValue > 1) {
        if (days[keyValue - 1]?.children?.length > 0) {
          daysIndex = keyValue - 1;
          newArray = days[daysIndex]?.children ?? [];
        } else if (days[days.length - 1]?.children?.length > 0) {
          daysIndex = days.length - 1;
          newArray = days[daysIndex]?.children ?? [];
        }
      }
      let weekDaysIndex = 0;
      if (weekDays?.length > 1 && keyValue > 1) {
        if (weekDays[keyValue - 1]?.children?.length > 0) {
          weekDaysIndex = keyValue - 1;
        } else if (weekDays[weekDays.length - 1]?.children?.length > 0) {
          weekDaysIndex = weekDays.length - 1;
        }
      }
      if (this.dateArr?.length === newArray.length && newArray.length > 0) {
        if (weekDays) {
          let rdrWeekDayWeekNumberLabelClassName = 'rdrWeekDayWeekNumberLabel';
          if (weekDays?.length > 1) {
            rdrWeekDayWeekNumberLabelClassName = `rdrWeekDayWeekNumberLabel rdrWeekDayWeekNumberLabel_${weekDaysIndex}`;
          }
          for (let i = 0; i < weekDays.length; i++) {
            if (i === weekDaysIndex) {
              let weekNumber = document.createElement("span");
              weekNumber.className = rdrWeekDayWeekNumberLabelClassName;
              weekNumber.innerHTML = `v`.translate(this.props.lang);
              weekDays[i].insertBefore(weekNumber, weekDays[i].childNodes[0]);
            }
          }
          let rdrWeekDay = document.getElementsByClassName("rdrWeekDay");
          for (let i = 0; i < rdrWeekDay?.length; i++) {
            rdrWeekDay[i]?.style?.setProperty("flex-basis", "calc(100% / 8)", "important");
          }
        }

        if (newArray.length > 0) {

          let rdrWeekNumberClassName = 'rdrWeekNumber';
          if (days?.length > 1) {
            rdrWeekNumberClassName = `rdrWeekNumber rdrWeekNumber_${daysIndex}`;
          }
          for (let i = 0; i < newArray.length; i++) {
            if (i === 0 || i % 8 === 0) {
              let element = document.createElement("div");
              element.className = rdrWeekNumberClassName;
              element.innerHTML = this.calculateWeekNumberByDate(this.dateArr[i]) ?? '';
              days?.[daysIndex]?.insertBefore?.(element, newArray[i]);
            }
          }
          let rdrDay = document.getElementsByClassName("rdrDay");
          for (let i = 0; i < rdrDay?.length; i++) {
            rdrDay[i]?.style?.setProperty("width", "calc(100% / 8)", "important");
          }
        }
      } else {
        if (number > 10) return;
        setTimeout(() => {
          this.calculateWeekNumbersCalendar(number + 1);
        }, 20 * number + 10);
      }
    }
  }
  render() {
    // console.log(this.props.value)
    let locale = null;

    if (typeof window !== "undefined" && iosDevice() && false) {
      locale = undefined;
    } else if (typeof window !== "undefined" && window._lang) {
      if (window._lang == "en") {
        locale = locales.enGB;
      } else {
        let domen = window.location.origin;
        let country = DOMAINS.find((item) => item.domen == domen)?.country;
        if (country == "sweden") {
          locale = locales.sv;
        } else if (country == "denmark") {
          locale = locales.da;
        } else if (country == "gr") {
          locale = locales.el;
        } else if (country == "es") {
          locale = locales.es;
        } else if (country == "ch") {
          locale = locales.de;
        } else {
          locale = locales.enGB;
        }
      }
    }
    return (
      <div

        className={
          this.props.error ? "date-picker-field required" : "date-picker-field"
        }
        ref={this.wrapperRef}
        style={{
          marginBottom: this.props.marginBottom ? this.props.marginBottom : 0,
        }}
      >
        {this.props.label ? <label>{this.props.label}</label> : null}
        <input
          value={this.props.value}
          disabled={this.props.disabled}
          // onChange={(e) => {
          //     if (e.target.value && e.target.value.split('/').length - 1 >= 2) {
          //         let splitted = e.target.value.split('/');
          //         if (splitted[2].length == 4) {

          //             let date = new Date(splitted[2], splitted[1] - 1, splitted[0], 0, 0, 0, 0);
          //             let date =
          //                 this.props.onChange(date);
          //         }
          //     }

          //     this.setState({
          //         value: e.target.value
          //     })
          // }}
          onClick={this.props.onClick}
          style={{
            height: this.props.heightInput
              ? this.props.heightInput
              : this.props.listOfMedicinesHide
                ? 0
                : null,
            visibility: this.props.listOfMedicinesHide ? "hidden" : "visible",
          }}
          type="text"
          onFocus={() => {
            if (!this.state.showCalendar) {
              this.setState(
                {
                  showCalendar: true,
                },
                () => {
                  if (typeof window != "undefined") {
                    window.stopVerifyFun = true;
                  }
                }
              );
            }
          }}
        />
        {this.props.icon ? (
          <div
            className="icon-date-send"
            onClick={() => {
              if (this.props.disabled) {
                this.setState({ showCalendar: false });
              } else {
                this.setState({ showCalendar: true });
              }
            }}
          >
            <Isvg src={this.props.icon} style={{ width: 32, minWidth: 32 }} />
          </div>
        ) : null}

        {
          this.props.holidayEvents && this.props.holidayEvents.length > 0 && this.props.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(this.props.value.replace(/-/g, "/")).getDate() && new Date(el.date).getMonth() === new Date(this.props.value.replace(/-/g, "/")).getMonth() && new Date(el.date).getFullYear() === new Date(this.props.value.replace(/-/g, "/")).getFullYear()).length > 0 ?
            <LightTooltipHoliday className="icon-date-holiday" title={this.props.holidayEvents?.filter(el => new Date(el.date).getDate() === new Date(this.props.value.replace(/-/g, "/")).getDate() && new Date(el.date).getMonth() === new Date(this.props.value.replace(/-/g, "/")).getMonth() && new Date(el.date).getFullYear() === new Date(this.props.value.replace(/-/g, "/")).getFullYear()).map((el, index) => {
              return <div key={index} >{this.props.lang === 'en' && el.titleEn ? el.titleEn : el.title}</div>
            })} placement="top-start" >
              <div className="svg-wrap">
                <Isvg src={holidayIcon} />
              </div>
            </LightTooltipHoliday>

            :
            null
        }

        {this.state.showCalendar || this.props.openCalendar ? (
          <Calendar
            minDate={
              this.props.endDate
                ? this.props.endDate
                : this.props.minDate
                  ? this.props.minDate
                  : new Date(1990, 1 - 1)
            }
            maxDate={this.props.maxDate}
            // maxDate={new Date(this.state.year, 11, 31)}
            date={
              this.props.value
                ? new Date(this.props.value.replace(/-/g, "/"))
                : this.state.date
            }
            locale={locale}
            // navigatorRenderer={(date, fun, obj) => {
            //     console.log(date, obj);
            // }}
            // showMonthAndYearPickers={true}
            // editableDateInputs={true}
            dayContentRenderer={(date) => {
              if (date) {
                let dateStr = moment.unix(new Date(date).getTime() / 1000).format('MM/DD/YYYY');
                let dateArr = this.dateArr?.length ? this.dateArr : [];
                if (!dateArr.includes(dateStr)) {
                  dateArr.push(dateStr);
                  this.dateArr = dateArr;
                }
              }

              if (this.props.holidayEvents && this.props.holidayEvents.length > 0) {
                if (this.props.holidayEvents.filter(el => new Date(el.date).getDate() === date.getDate() && new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()).length > 0) {

                  const tooltip = this.props.holidayEvents?.filter(el => new Date(el.date).getDate() === date.getDate() && new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()).map((el, index) => {
                    return <div key={index} >{this.props.lang === 'en' && el.titleEn ? el.titleEn : el.title}</div>
                  })

                  const content = <div style={{ position: 'absolute', zIndex: 2, width: '100%' }}>
                    <span>{format(date, "d")}</span>
                    <span style={{ borderRadius: '50%', width: 10, height: 10, backgroundColor: 'red', position: 'absolute' }}></span>
                  </div>

                  if (tooltip) {
                    return (
                      <LightTooltipHoliday title={tooltip} placement="top-start" >
                        {content}
                      </LightTooltipHoliday>
                    )
                  } else {
                    return (
                      <div>
                        <span>{format(date, "d")}</span>
                      </div>
                    )
                  }

                } else {
                  return (
                    <div>
                      <span>{format(date, "d")}</span>
                    </div>
                  )
                }
              }

              return (
                <div>
                  <span>{format(date, "d")}</span>
                </div>
              )
            }}

            onShownDateChange={(date) => {
              this.dateArr = [];
              this.calculateWeekNumbersCalendar();
              // console.log(date);
              let d = new Date(date);
              if (this.props.value) {
                const daysInMonth = getMaxDaysInCurrentMonth(date);
                let currentDate = new Date(this.props.value.replace(/-/g, "/")).getDate();
                let dateValue = currentDate > daysInMonth ? daysInMonth : currentDate;
                d.setDate(
                  dateValue
                );
              }

              this.props.onChange(
                moment(d).format(
                  this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                )
              );
            }}
            onChange={(date) => {

              this.setState(
                {
                  showCalendar: null,
                  // value:moment(new Date(date)).format('YYYY-MM-DD')
                },
                () => {
                  // if(typeof window != 'undefined'){
                  //     window.stopVerifyFun = false
                  // }
                }
              );
              this.props.onChange(
                moment(new Date(date)).format(
                  this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                )
              );
              if (this.props.openCalendar) this.props.closeCalendar();
            }}
          />
        ) : null}
      </div>
    );
  }
}

export default DatePicker;
